var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAstronaut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2738.55 1980.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d3e8f9;}.cls-2{fill:#87b4de;}.cls-3{fill:#0a1324;}.cls-4{fill:#3279af;}.cls-5{fill:#fff;}.cls-6{fill:none;stroke:#0a1324;stroke-linecap:round;stroke-linejoin:round;stroke-width:10px;}.cls-7{fill:#1f3e76;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1601.72,76.86c-485.1-115.32-2018.19,1505.22-1493.95,1643,362.28,95.18,1047.41-674.54,1228.65-570.33,169,97.21-139,489.7,26.48,535.24,280.31,77.16,1680.42-1441.1,1315.34-1642.57C2319.16-156,1906.82,412.58,1790.89,346.57S1741.07,110,1601.72,76.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2250.4,
    cy: 1664.99,
    r: 239.84,
    transform: "translate(-518.2 2078.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2185,1498.81c-.57,18.14-12.15,41.53-32.18,61.56s-43.42,31.61-61.56,32.17c.57-18.13,12.16-41.54,32.18-61.55S2166.81,1499.38,2185,1498.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2390.37,1698.49c-.78,24.86-16.64,56.91-44.08,84.34s-59.48,43.29-84.33,44.08c.78-24.84,16.64-56.88,44.07-84.33S2365.52,1699.28,2390.37,1698.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1182.34,1371.73s222.56,61,268.7,42.09,277.48-430.67,302.18-478.15-44.47-216.85-69.17-299.12-206.28-121.7-206.28-121.7-247,.62-373,373.89S1182.34,1371.73,1182.34,1371.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1529.91,529.46c-29.93-9.79-52.14-14.61-52.14-14.61s-101.67.26-207.84,99c49.51,26.34,119.27,53.5,149.57,18.27C1451.23,595.28,1499.42,554.19,1529.91,529.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M875.49,921.13c-52.62-41.31-40.07-104.58-40.07-104.58,42-66.49,115.45-63.42,139.65-26.06S875.49,921.13,875.49,921.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1424.42,1105.87c-21.17,21.16-49.9,15.87-74.23-9.48-.09,1.19-5.87,75.56-72.69,142.48-67.35,67.45-121,153.18-106.19,212.83,4.93,19.81,19.09,43.47,36.35,70.06l2.82,154.76-181.67-37.16L865,1676.52l-93-91.7c-57.86-63.39-120.78-147-117.7-208,5.65-112,294.16-577,294.16-577s4.1-67.26,46-134.83c57.92-93.34,164.09-138.67,164.09-138.67s73.35-20.94,143.76-4.38,160.15,67.75,234.53,156S1473.41,1056.87,1424.42,1105.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1230.06,515.85s-83.41-125.63-31-225.87,183-156,292.47-73.62c86.71,65.27,76.22,163.74,48.75,217.53s-90.15,119.27-143,124.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1230.06,515.85,1266,467.77c102,0,103.57,78.27,103.57,78.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1486.34,307.17c0,35.72-73.8,87-101.71,86.72-26.21-.23-114.29-67.7-199.69-63.48A149,149,0,0,1,1199,290c26.85-51.37,74.24-91.07,128.8-106.48C1435.82,198.68,1486.34,273.28,1486.34,307.17Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1387.96,
    y1: 841.82,
    x2: 1451.04,
    y2: 935.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1342.83,692.11s34.56-80.62,108.21-95.62h16.09a45.93,45.93,0,0,1,23.63,6.53h0a46,46,0,0,1,22.15,35l1.47,15.05S1466,632.38,1388,750.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M968.74,639.89c27-47.3,94-114.06,120.4-118s69.47,4.38,69.47,4.38S1081.38,559.67,1005,682.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1350.28,1096.38h0c0,.64-1.78,22.34-13.65,52.66-87-172.52-255.91-176.15-255.91-176.15l35.5-59.25s114.51,7,188.5,75.49C1311.31,1037.2,1329.28,1074.36,1350.28,1096.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1304.42,907.08c-10.54,88,13.79,156,45.77,189.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1651.79,
    y1: 670.59,
    x2: 1551.68,
    y2: 817.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1371.15,
    y1: 1185.8,
    x2: 1436.64,
    y2: 1369.94
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1651.79 790.88 1587.59 884.12 1663.47 1017.09 1721.2 913.65 1651.79 790.88"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 554.69,
    cy: 233.28,
    r: 191.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2177.5,1476.88c16.23,16.23,5.16,53.61-24.72,83.49s-67.26,40.94-83.49,24.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2272.17,1857c-22.23-22.23-7.07-73.44,33.87-114.38s92.15-56.1,114.38-33.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M745.8,231.39c-49.66,22.85-106.25,46.14-167,68.24s-119,40.63-171.79,55c-133.93,36.59-231.87,46.52-241.44,20.23s71.83-81.66,198-139.72a190.79,190.79,0,0,0,2.22,27.43c-54.17,29.27-85.85,54.92-80.78,68.83s45.82,13.2,106.12.8c49.8-10.25,112.93-28.46,180.29-53S698.85,228.12,743.58,204c54.17-29.26,85.85-54.92,80.78-68.82s-45.82-13.2-106.12-.81a191.44,191.44,0,0,0-15.91-22.44C836.26,75.3,934.19,65.38,943.76,91.67S871.93,173.32,745.8,231.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M323.1,1332.12s3.59,119.59-102,119.59c0,0,102-1.34,102,122.6,0,0-12.63-121.1,92.92-121.1C416,1453.21,323.1,1446.13,323.1,1332.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2218.4,224.78s-82,87.1-156.66,12.47c0,0,73,71.15-14.59,158.78,0,0,76.7-94.55,151.33-19.92C2198.48,376.11,2137.78,305.4,2218.4,224.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M757,1131.6s123.73-26.88,197,54.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M968.74,1148.14s167-54.84,272,131.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M688.19,1271.32s106.16-42.46,226.15,45.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M922.2,1284s150.63-62.46,254.89,101.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M659.09,1413.14s108.88,28.41,248.51,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M912.34,1434.54s106,49.82,256.57,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1415.77,571.56c-102.57-5.24-152.48,87.91-152.48,87.91l-147.08-27.31c0-64.22,69.21-111.58,69.21-111.58s41.36-29.34,125.74-13.68S1415.77,571.56,1415.77,571.56Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "957.45 898.85 891.63 893.85 863.02 942.39 950.89 955.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1551.68,1280.57s39.68,193.16,181.88,193.16c197.34,0,220.4-736.89,407.08-768.23S2260.12,964.21,2495.24,952c0,0,27.55,34.37,10.79,86.67s-68.31,61.71-68.31,61.71c-244.39-38.89-149.43-329.17-282.75-285.08s-140.39,755.66-411,755.66c-181.29,0-252.39-201-252.39-201"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2482,969.4s-69,20.62-40.42,110.61C2441.54,1080,2528.29,1052.83,2482,969.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2456.42,985.19s78.3,18.46,112.65-49.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2436.62,1060.59s70.63,10,84.37,111"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2434.85,1032.62s114.76,12.24,149.1,54.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2442.3,1004.36s81,19,141.65,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1578.28,
    y1: 1356.13,
    x2: 1528.64,
    y2: 1441.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1642.31,
    y1: 1441.32,
    x2: 1601.72,
    y2: 1521.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1721.2,
    y1: 1473.22,
    x2: 1713.07,
    y2: 1568.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1790.89,
    y1: 1450.56,
    x2: 1841.85,
    y2: 1534.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1843.91,
    y1: 1378.7,
    x2: 1926.2,
    y2: 1417.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1891.55,
    y1: 1263.78,
    x2: 1978.31,
    y2: 1284.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1930.85,
    y1: 1137.04,
    x2: 2017.56,
    y2: 1149.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1973.43,
    y1: 989.81,
    x2: 2050.98,
    y2: 1024.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2028.55,
    y1: 832.95,
    x2: 2091.77,
    y2: 898.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2140.64,
    y1: 705.5,
    x2: 2154.97,
    y2: 815.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2413.78,941.44s-75.4,45.44-50.63,134.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2338.77,884.61s-59,32-68.24,84.79"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2273.09,
    y1: 773.29,
    x2: 2227.98,
    y2: 848.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1023.72,1801c-29.8,57.45-88.81,161.08-172.46,134.86S802.39,1795.28,865,1676.52a1258.45,1258.45,0,0,1-93-91.7c1.69.92,104.08,55.79,190.41-43.67,14.89,24.78,31.37,49.43,47.63,72.34l0,0c11.21,15.83,22.32,30.85,32.75,44.51a.57.57,0,0,0,.08.13C1068.87,1693.31,1053.5,1743.68,1023.72,1801Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1046.31,1660.57c-49.75-26.41-190.55-112.74-199-247.42-8-126.39,91.15-251.17,136.84-301.58-32.79,75.44-88.82,219.9-76.51,301.58,5.52,36.63,27.52,82.55,54.86,128C987.11,1579,1022.39,1628,1046.31,1660.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1140.23,1980.81c-108,4.75-87.19-139.92-38.5-249.59,0,0-25.88-29.83-58.8-73.06a.57.57,0,0,1-.08-.13c-10.43-13.66-21.54-28.68-32.75-44.51,1.16.89,54.19,41,127.9,7.23,74.54-34.15,69.66-99,69.66-99,34.75,53.51,82,118.89,91.82,188.61C1309,1778.49,1248.27,1976.06,1140.23,1980.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1005.39,709.53C1002,720.72,958.12,802,948.5,799.82c-5.86-1.31-23.73-3.52-36.29-9.75-.13.83-6,39.56-23.24,41.86-17.41,2.31-39.62,2-53.55-15.38s44.05-159.69,64.19-177.47c17.86-15.77,72.31-1,88.68,9.25S1008.75,698.34,1005.39,709.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M912.28,790.46v-.39c-8-4-13.92-9.61-13.09-17.69,2.14-20.71,22.45-14.1,22.45-14.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 968.74,
    y1: 659.47,
    x2: 933.05,
    y2: 724.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1342.83,691.89c-29.08-10.12-89.85,20.91-96,35.41s8.13,21.45,7.69,41.88-25.74,98.19-6.63,110.51,56,28.65,77.59,33.76,79.3-89,75.51-111.48S1382.68,705.77,1342.83,691.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1336.42,724.43s-20.65,111.14-36.93,132.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "968.74 876.62 938.76 935.67 950.89 955.99 1080.7 972.9 1116.21 913.65 1104.74 888.74 968.74 876.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "974.09 898.85 963.83 921.13 1017.72 926.22 1025.21 902 974.09 898.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1010.1,1613.52s-21.21-30.26-47.65-72.37c-27.34-45.45-49.34-91.37-54.86-128-17.19-114.07,98.89-350.56,98.89-350.56"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronaut);
export default __webpack_public_path__ + "static/media/astronaut.d22fc760e519a1b6a46bcc004ddaae3e.svg";
export { ForwardRef as ReactComponent };